<template>
  <v-container fluid class="px-0 py-0">
    <CommonDetail
        :uid-item="uidItem"
        :store-name="storeName"
        :dto-detail-query="dtoDetailQuery"
        :dto-save-command="dtoSaveCommand"
        :dto-action-command="dtoActionCommand"
        :dto-validate-command="dtoValidateCommand"
        :main-validator="mainValidator"
        :modal-dialog="modalDialog"
        :parent-component="parentComponent"
        :wrap-component="$options.name"
        @close="$emit('close')"
    >
      <template v-slot:body>
        <v-sheet class="px-3" v-if="!!storeAggregate.rootData && !!storeDetail.uidItem">
          <BaseFieldString
              v-model="storeAggregate.rootData[storeDetail.uidItem].name"
              label="Name"
              class="mt-3"
          ></BaseFieldString>
          <BaseFieldString
              v-model="storeAggregate.rootData[storeDetail.uidItem].alias"
              label="ClientReplica ID"
              class="mt-3"
          ></BaseFieldString>
        </v-sheet>
      </template>
    </CommonDetail>
  </v-container>
</template>

<script>
import {useAggregateStore} from '@/store/CommonStore/baseAggregateStore'
import {useDetailStore} from "@/components/Common/CommonDetail";
import CommonDetail from "@/components/Common/CommonDetail";
import BaseFieldString from "@/components/Base/BaseFieldString";
import BaseFieldCheck from "@/components/Base/BaseFieldCheck";

export default {
  name: "ClientReplicaDetail",

  props: {
    uidItem: {default: null},
    storeName: {type: [String], default: 'ClientReplicaDetail'},
    dtoDetailQuery: {default: 'ClientReplicaDetailQueryDTO'},
    dtoActionCommand: {type: [String], default: 'ClientReplicaActionCommandDTO'},
    dtoSaveCommand: {type: [String], default: 'ClientReplicaSaveCommandDTO'},
    dtoValidateCommand: {type: [String], default: 'ClientReplicaValidateCommandDTO'},
    dtoModelForValidate: {type: [String], default: 'ClientReplicaBaseDTO'},
    mainValidator: {type: [Boolean], default: true},
    modalDialog: {type: [Boolean], default: false},
    parentComponent: {type: [String], default: 'ClientReplicaTable'},
    routeFullScreen: {type: [Object], default: null},
  },

  components: {
    BaseFieldCheck,
    BaseFieldString,
    CommonDetail,
  },

  computed: {},

  methods: {}
  ,


  mounted() {
    this.storeDetail = useDetailStore(this.storeName)()
    this.storeAggregate = useAggregateStore()
  }
  ,

  data() {
    return {
      storeDetail: null,
      storeAggregate: null,
    }
  }
  ,
}
</script>

<style scoped>

</style>